const prefix = '/api/v1/financial-calendar' as const;

export const financialCalendarPaths = {
  events: `${prefix}/events`,
  // TRAD-2071: 기본 노출(HIGH만) 정책의 "전체 M건" 고지용 — /events(Page<>)와 분리된 경량 집계 엔드포인트.
  dailyCounts: `${prefix}/events/daily-counts`,
} as const;
